import { Avatar, Checkbox, Dropdown, message, Modal, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFamilyMembers,
  clearSelectedEditPatient,
  clearSelectedPatient,
  fetchPatients,
  fetchPatientsCount,
  setSelectedEditPatient,
  setSelectedPatient,
} from "../Redux/actions/patientActions";
import PatientService from "../Services/PatientService";
import { FaUser } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import PatientDetailsView from "../Components/Pages/PatientList/PatientProfileView";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_ROUTES } from "../PageRouting/PageRoutes";
import { fetchRpmPatientFilterCount } from "../Redux/actions/rpmActions";
import Single from "../Assets/Icons/single.svg";
import Twin from "../Assets/Icons/twin.svg";
import Family from "../Assets/Icons/family.svg";
import { calculateAge } from "../utils/convertionFunc";
import nosearchfound from "../Assets/Icons/nosearchfound.svg";
import AddNewPatient from "../Components/Pages/PatientList/AddNewPatient";
import {
  BellOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useNavigation } from "../Context/NavigationContext";
// import MedicineReminderModal from "../Components/Pages/OrderMedicine/medicineReminder";
import MedicineReminderModal, {MedicineReminderListModal,} from "../Components/Pages/OrderMedicine/medicineReminder";

const patientForm = {
  firstName: "",
  lastName: "",
  salutation: "",
  mobile: "",
  email: "",
};

const formLoadingValues = {
  // firstName: '',
  // lastName: '',
  patientName: "",
  mobile: "",
};

function PatientSearch() {
  const [loader, setLoader] = useState(false);
  const [patRegLoader, setPatRegLoader] = useState(false);
  const [patSearchMod, setPatSearchMod] = useState(false);
  const [searchValue, setSearchValue] = useState(formLoadingValues);
  const [isNoPatAvailable, setIsNoPatAvailable] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [searchedPatList, setSearchedPatList] = useState([]);
  const [currSelPat, setCurrSelPat] = useState(null);
  const [detailedView, setDetailedView] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("critical");
  const [regModal, setRegModal] = useState(false);
  const [formData, setFormData] = useState(patientForm);
  const { selectedPatient } = useSelector((state) => state.patients);
  const { rpmPatientFiltersCount } = useSelector((state) => state.rpm);
  const { navigate, isPending } = useNavigation();
  const history = useHistory();
  const dispatch = useDispatch();
  const nameRef = useRef(null);
  const mobileRef = useRef(null);
  const idRef = useRef(null);
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const membership = sessionStorage.getItem("membership");

  // Medicine Reminder list modal
  const [medReminderOpen, setMedReminderOpen] = useState(false);
  // const [medReminderList, setMedReminderList] = useState([]);
  // const [medReminderLoading, setMedReminderLoading] = useState(false);

  // Medicine Reminder create/edit modal (reuses your MedicineReminderModal component)
  const [medReminderAddOpen, setMedReminderAddOpen] = useState(false);

  useEffect(() => {
    if (loggedUser?.user && loggedUser.user.rpmApplicable === "Y") {
      const payload = {
        user_account_Id: loggedUser.user.account_Id,
        user_clinic_Id: loggedUser.user.clinic_Id,
        status: 1,
      };
      dispatch(fetchRpmPatientFilterCount(payload));
    }
  }, []);

  const handleSearchModal = () => {
    setPatSearchMod(!patSearchMod);
    setShowSearchResult(false);
  };

  const handleSelectedPatient = async () => {
    if (!currSelPat) {
      message.error("Please select a patient");
      return;
    }
    if (currSelPat) {
       sessionStorage.removeItem("membership");
      dispatch(setSelectedPatient(currSelPat));
      sessionStorage.setItem("selectedPatient", JSON.stringify(currSelPat));
      if (currSelPat?.membershipCard) {
        const payload = {
          // patientId:currSelPat?.patientId,
          membershipCard: currSelPat?.membershipCard,
        };
        const response = await PatientService.patientMembershipDet(payload);
        if (response?.data?.data?.[0]) {
          sessionStorage.setItem(
            "membership",
            response?.data?.data?.[0].membershipCode,
          );
        }
      }

      setCurrSelPat(null);
      setPatSearchMod(!patSearchMod);
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "patientId",
      render: (patientId, record) => (
        <Checkbox
          className=""
          checked={currSelPat && currSelPat.patientId === patientId}
          onChange={(e) => handleRadioChange(e, record)}
        />
      ),
    },
    {
      title: "Patient ID",
      dataIndex: "patientId",
      key: "patientId",
    },
    {
      title: "Name",
      dataIndex: "firstName",
      key: "name",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },
  ];

  const handleRadioChange = (e, record) => {
    if (e.target.checked) {
      setCurrSelPat(record);
    } else {
      setCurrSelPat(null);
    }
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhoneNumber = (number) => /^\d{10,15}$/.test(number);

  const handleSearch = async () => {
    if (
      !idRef.current?.value.trim() &&
      !mobileRef.current?.value.trim() &&
      !nameRef.current?.value.trim()
    ) {
      message.error("Please provide data in any of the fields.");
      return;
    }

    if (
      mobileRef.current?.value.trim() &&
      !validatePhoneNumber(mobileRef.current?.value.trim())
    ) {
      message.error("Please enter a valid mobile number.");
      return;
    }
    setSearchValue(formLoadingValues);

    const formData = {
      // firstName: nameRef.current?.value.split(' ')[0],
      // ...(nameRef.current?.value.split(' ')[1] && { lastName: nameRef.current?.value.split(' ')[1] }),
      patientName: nameRef.current?.value?.trim(),
      patientMobile: mobileRef.current?.value.trim(),
      patientId: idRef.current?.value.trim(),
    };

    const payload = {};
    // if (loggedUser?.user?.rolecode === "ACCT_ADM") {
    //   payload.account_Id = loggedUser.user.account_Id;
    // } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
    //   payload.account_Id = loggedUser.user.account_Id;
    //   payload.clinic_Id = loggedUser.user.clinic_Id;
    // }

    if (formData.patientMobile) {
      payload.mobile = formData.patientMobile;
      setSearchValue((prevState) => ({
        ...prevState,
        mobile: formData.patientMobile,
      }));
    }
    // if (formData.patientId) {
    //   payload.patientId = formData.patientId;
    // }
    if (formData.patientName) {
      payload.patientName = formData.patientName;
      setSearchValue((prevState) => ({
        ...prevState,
        patientName: formData.patientName,
      }));
    }

    // if (formData.lastName) {
    //   payload.lastName = formData.lastName;
    //   setSearchValue((prevState) => ({ ...prevState, lastName: formData.lastName }));
    // }

    setLoader(true);
    setIsNoPatAvailable(false);
    try {
      const response = await PatientService.PatientList(payload);
      setShowSearchResult(true);
      if (!response.data) {
        setIsNoPatAvailable(true);
        return;
      }
      if (response.data && loggedUser?.user.rolecode !== "SUPERADMIN") {
        const allPatients = response.data;

        //  RPM-applicable patients with same hospital + location
        let rpmPatients;
        let sameAccClinicPatients;
        if (loggedUser?.user.rolecode === "CLINIC_ADM") {
          rpmPatients = allPatients.filter(
            (item) =>
              item.rpmApplicable === "Y" &&
              item.hospitalId === loggedUser.user.account_Id &&
              item.locationId === loggedUser.user.clinic_Id,
          );

          //  Normal patients with same account + clinic
          sameAccClinicPatients = allPatients.filter(
            (item) =>
              item.account_Id === loggedUser.user.account_Id &&
              item.clinic_Id === loggedUser.user.clinic_Id,
          );
        } else if (loggedUser?.user.rolecode === "ACCT_ADM") {
          rpmPatients = allPatients.filter(
            (item) =>
              item.rpmApplicable === "Y" &&
              item.hospitalId === loggedUser.user.account_Id,
          );

          //  Normal patients with same account + clinic
          sameAccClinicPatients = allPatients.filter(
            (item) => item.account_Id === loggedUser.user.account_Id,
          );
        }

        // 3️⃣ Combine both sets, removing duplicates by patientId
        const combinedPatients = [
          ...rpmPatients,
          ...sameAccClinicPatients.filter(
            (p) => !rpmPatients.some((r) => r.patientId === p.patientId),
          ),
        ];
        if (combinedPatients?.length === 0) setIsNoPatAvailable(true);
        setSearchedPatList(combinedPatients || []);
      } else {
        setSearchedPatList(response.data);
      }
    } catch (e) {
      console.log(e);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleClearPatient = () => {
    dispatch(clearSelectedPatient(null));
     sessionStorage.removeItem("selectedPatient");
     sessionStorage.removeItem("membership");
    clearSelectedPatientData();
    let urls = [
      APP_ROUTES.BOOKAPPOINTMENT,
      APP_ROUTES.BOOKMEDICINES,
      APP_ROUTES.MEDICINEDETAILS,
      APP_ROUTES.LABTEST,
      APP_ROUTES.TESTDETAILS,
      APP_ROUTES.PROCEDURAL,
      APP_ROUTES.BOOKPROCEDURE,
      APP_ROUTES.DIETPLAN,
      APP_ROUTES.FAMILYMEMBERS,
      APP_ROUTES.MEDICALHISTORY,
      APP_ROUTES.VITALS,
      APP_ROUTES.PRESCRIPTIONS,
      APP_ROUTES.REPORTS,
      APP_ROUTES.CONSENT,
      APP_ROUTES.PATIENTDEVICES,
      APP_ROUTES.MYCART,
    ];
    if (urls.includes(window.location.pathname)) {
      history.push(APP_ROUTES.DASHBOARD);
    }
  };

  const clearSelectedPatientData = () => {
    dispatch(clearFamilyMembers());
  };

  const handlePatDetView = () => {
    setDetailedView(true);
    const selePatientJson = sessionStorage.getItem("selectedPatient");
    const selectedPatient = selePatientJson
      ? JSON.parse(selePatientJson)
      : null;
    dispatch(setSelectedEditPatient(selectedPatient));
  };

  const handleCloseProfile = () => {
    setDetailedView(false);
    dispatch(clearSelectedEditPatient(null));
  };

  const handleSave = () => {
    setDetailedView(false);
    const patientPayload = { pageNo: 0 };
    if (loggedUser?.user?.rolecode === "ACCT_ADM") {
      patientPayload.account_Id = loggedUser.user.account_Id;
    } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
      patientPayload.account_Id = loggedUser.user.account_Id;
      patientPayload.clinic_Id = loggedUser.user.clinic_Id;
    }
    dispatch(fetchPatients(patientPayload));
    dispatch(fetchPatientsCount(patientPayload));
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    sessionStorage.setItem("category", category);
    if (category === "critical") {
      history.push(APP_ROUTES.PATIENTCRITICAL, { data: category });
    } else if (category === "abnormal") {
      history.push(APP_ROUTES.PATIENTABNORMAL, { data: category });
    } else if (category === "normal") {
      history.push(APP_ROUTES.PATIENTNORMAL, { data: category });
    }
  };

  const menuItems = [
    {
      key: "profile",
      label: "Profile",
      onClick: handlePatDetView,
    },
    // { type: "divider" },
    {
      key: "family-members",
      label: "Family Members",
      onClick: () => history.push(APP_ROUTES.FAMILYMEMBERS),
    },
    {
      key: "order-history",
      label: "Order History",
      onClick: () => history.push(APP_ROUTES.ORDERHISTORY),
    },
    {
      key: "medical-history",
      label: "Medical History",
      onClick: () => history.push(APP_ROUTES.MEDICALHISTORY),
    },
    {
      key: "vitals",
      label: "Vitals",
      onClick: () => history.push(APP_ROUTES.VITALS),
    },
    {
      key: "prescriptions",
      label: "Prescriptions",
      onClick: () => history.push(APP_ROUTES.PRESCRIPTIONS),
    },
    {
      key: "reports",
      label: "Reports",
      onClick: () => history.push(APP_ROUTES.REPORTS),
    },
    {
      key: "patient-consent",
      label: "Consent",
      onClick: () => history.push(APP_ROUTES.CONSENT),
    },
    {
      key: "patient-devices",
      label: "Devices",
      onClick: () => history.push(APP_ROUTES.PATIENTDEVICES),
    },
  ];

  const handleNewPatRegModal = () => {
    if (searchValue.mobile)
      setFormData((prevState) => ({
        ...prevState,
        mobile: searchValue.mobile,
      }));
    if (searchValue.firstName && /^[A-Za-z ]+$/.test(searchValue.firstName)) {
      setFormData((prev) => ({
        ...prev,
        firstName: searchValue.firstName,
      }));
    }

    if (searchValue.lastName && /^[A-Za-z ]+$/.test(searchValue.lastName)) {
      setFormData((prev) => ({
        ...prev,
        lastName: searchValue.lastName,
      }));
    }
    setRegModal(true);
  };

  const handleCloseRegModal = () => {
    setRegModal(false);
    setFormData(patientForm);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNewPatRegistration = async () => {
    const { salutation, firstName, lastName, email, mobile } = formData;

    if (!firstName || !mobile) {
      message.error("Please fill in all mandatory fields");
      return;
    }
    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;

    if (!validatePhoneNumber(mobile)) {
      message.error("Please enter a valid mobile number.");
      return;
    }

    if (email && !validateEmail(email)) {
      message.error("Please enter a valid mail id.");
      return;
    }

    const payload = {
      account_Id: loggedUser.user?.account_Id,
      account_Name: selectedPatient?.account_Name,
      address1: null,
      address2: null,
      bloodGroup: null,
      city: null,
      clinic_Id: loggedUser.user?.clinic_Id,
      clinic_Name: loggedUser.user?.clinic_Name,
      country: null,
      createdBy: loggedUser.user?.userId,
      createdDate: constructedTime,
      dob: null,
      email: email ? email : null,
      firstName,
      gender: null,
      lastName: lastName ? lastName : "",
      loginId: null,
      loginIdAvailableYN: null,
      maritalStatus: null,
      meetingLink: null,
      mobile,
      modifiedBy: loggedUser.user?.userId,
      modifiedDate: constructedTime,
      parentPatientId: null,
      parentPatientName: null,
      patientId: null,
      patientRegFee: 0,
      patientRegFeeYN: null,
      photo: null,
      photoName: null,
      photoType: null,
      pinCode: null,
      relationCode: null,
      relationDescription: null,
      salutation: salutation ? salutation : null,
      state: null,
      status: 1,
      userId: loggedUser.user?.userId,
      userName: loggedUser.user?.userName,
      rpmApplicable: "N",
      patientChronicConditionsList: [],
      patientDevicesList: [],
      patientVitalsConfigList: {
        bloodGlucose: 0,
        bmi: 0,
        diastolic: 0,
        heartRate: 0,
        height: 0,
        respiratoryRate: 0,
        spo2: 0,
        systolic: 0,
        temperature: 0,
        weight: 0,
        breathing: 0,
        pulse: 0,
        spirometry: 0,
        createdBy: "",
        modifiedBy: "",
        status: 1,
      },
      patientVitalsRangeList: [],
      hospitalId: "",
      locationId: "",
      uhId: "",
      insuranceId1: "",
      insuranceId2: "",
      insuranceName1: "",
      insuranceName2: "",
      patientGroupNumber: "",
      height: 0,
      weight: 0,
      providerName: "",
      providerCode: "",
      patientRegConsentDtlList: [],
      sos: "N",
      erContactNo1: "",
      erContactNo2: "",
      erContactNo3: "",
      erContactNo4: "",
      erContactNo5: "",
      rpmSmartWatch: "N",
      smartWatchUserId: "",
    };

    console.log(" payload ", payload);
    setPatRegLoader(true);
    try {
      await PatientService.AddPatient(payload);
      message.success("Patient created successfully!!");
      handleCloseRegModal();
    } catch (e) {
      setPatRegLoader(false);
      console.log(e);
      e && message.error(e.response.data.message);
    } finally {
      setPatRegLoader(false);
    }
  };

  const handleDietRouting = () => {
    navigate(APP_ROUTES.DIETPLAN);
  };

  const handleMedicineReminder = () => {
  if (!selectedPatient) {
    message.error("Please select a patient");
    return;
  }
  setMedReminderOpen(true);
};

  // ─── Medicine Reminder Card ───────────────────────────────────────────────────
  const MedicineReminderCard = ({ item }) => {
    const activeSlots = [
      item.morningAppl === "Y" && { label: "Morning", time: item.morningTime },
      item.afternoonAppl === "Y" && {
        label: "Afternoon",
        time: item.afternoonTime,
      },
      item.eveningAppl === "Y" && { label: "Evening", time: item.eveningTime },
      item.nightAppl === "Y" && { label: "Night", time: item.nightTime },
    ].filter(Boolean);

    const fromDate = item.notificationFromDate?.split(" ")[0];
    const toDate = item.notificationToDate?.split(" ")[0];

    const slotColors = {
      Morning: "bg-amber-50   text-amber-600   border-amber-200",
      Afternoon: "bg-orange-50  text-orange-500  border-orange-200",
      Evening: "bg-purple-50  text-purple-500  border-purple-200",
      Night: "bg-indigo-50  text-indigo-500  border-indigo-200",
    };

    return (
      <div className="border border-gray-200 rounded-xl p-3 mb-2 bg-white hover:border-[#189FAA] hover:shadow-sm transition-all">
        {/* Drug name + prescription badge */}
        <div className="flex items-start justify-between gap-2 mb-2">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#e6f7f8] flex items-center justify-center flex-shrink-0">
              <BellOutlined style={{ color: "#189FAA", fontSize: 14 }} />
            </div>
            <p className="text-sm font-semibold text-gray-800 leading-tight">
              {item.drugName}
            </p>
          </div>
          {item.prescriptionId ? (
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#e6f7f8] text-[#189FAA] font-medium border border-[#189FAA]/20 whitespace-nowrap flex-shrink-0">
              Rx: {item.prescriptionId}
            </span>
          ) : (
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-400 font-medium whitespace-nowrap flex-shrink-0">
              Manual
            </span>
          )}
        </div>

        {/* Active slots */}
        {activeSlots.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-2 pl-10">
            {activeSlots.map(({ label, time }) => (
              <span
                key={label}
                className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border font-medium ${slotColors[label]}`}
              >
                <ClockCircleOutlined style={{ fontSize: 10 }} />
                {label} · {time?.slice(0, 5)}
              </span>
            ))}
          </div>
        )}

        {/* Date range */}
        <div className="flex items-center gap-1 pl-10 text-xs text-gray-400">
          <CalendarOutlined style={{ fontSize: 11 }} />
          <span>
            {fromDate} → {toDate}
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="w-full flex gap-2 items-center justify-between bg-white relative py-1">
        <div className="w-2/5 flex items-center gap-3 ml-9">
          {selectedPatient && (
            <>
              <div className="flex justify-center mr-1.5">
                <div className="flex items-center gap-3">
                  <Dropdown
                    menu={{ items: menuItems }}
                    trigger={["hover"]}
                    placement="bottomLeft"
                  >
                    <div
                      // onClick={handlePatDetView}
                      className="w-14 h-14 flex items-center justify-center rounded-lg p-0 m-0 border-[#D0E2E1] border cursor-pointer bg-white"
                    >
                      {selectedPatient?.photoName ? (
                        <Avatar
                          style={{ width: "100px", height: "55px" }}
                          src={`${process.env.REACT_APP_IMAGE_URL}${selectedPatient?.photoName}`}
                          className="rounded-lg object-cover"
                          alt="Logo"
                        />
                      ) : (
                        <FaUser className="w-6 h-6" />
                      )}
                    </div>
                  </Dropdown>
                  <div>
                    <Tooltip
                      title={
                        selectedPatient?.firstName +
                        " " +
                        selectedPatient?.lastName
                      }
                    >
                      <p className="font-inter font-semibold text-sm text-[#333333]">
                        {selectedPatient?.firstName +
                          " " +
                          (selectedPatient?.lastName?.length > 10
                            ? `${selectedPatient?.lastName?.slice(0, 10)}...`
                            : selectedPatient?.lastName)}
                      </p>
                    </Tooltip>
                    <div className="flex items-center font-inter font-normal text-sm text-[#333333]">
                      <span>
                        {selectedPatient?.gender || "-"}/
                        {calculateAge(selectedPatient?.dob)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {membership && (
                <div
                  className={`w-max h-max p-[1.5px] rounded-md bg-gradient-to-r ${
                    membership === "SINGLE"
                      ? "from-[#81CAF4] to-[#58B4E9]"
                      : membership === "TWIN"
                        ? "from-[#5DEB6D] to-[#34CF47]"
                        : membership === "FAMILY"
                          ? "from-[#35D9D4] to-[#1DBBB6]"
                          : ""
                  }`}
                >
                  <div className="p-1.5 rounded-md flex items-center gap-1 bg-white">
                    <div>
                      {membership === "SINGLE" ? (
                        <img className="h-5" src={Single} alt={membership} />
                      ) : membership === "TWIN" ? (
                        <img className="h-5" src={Twin} alt={membership} />
                      ) : membership === "FAMILY" ? (
                        <img className="h-5" src={Family} alt={membership} />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="font-medium text-xs">
                      <p>
                        {membership === "SINGLE"
                          ? "Single"
                          : membership === "TWIN"
                            ? "Twin"
                            : membership === "FAMILY"
                              ? "Family"
                              : ""}
                      </p>
                      <p>
                        {membership === "SINGLE"
                          ? "Member"
                          : membership === "TWIN"
                            ? "Members"
                            : ""}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div
                className="cursor-pointer mb-8 items-start"
                onClick={handleClearPatient}
              >
                <IoMdCloseCircle className="text-brand-textGray" />
              </div>
            </>
          )}
        </div>
        <div className="flex-1 flex items-center gap-1.5">
          <div
            onClick={handleSearchModal}
            className="w-3/5 flex h-10 px-2 items-center border focus-within:border-indigo-500 transition duration-300 gap-2 rounded-[5px] overflow-hidden"
          >
            <FiSearch className="text-gray-500 text-lg" />
            <input
              type="text"
              placeholder="Search patient"
              value={""}
              className=" h-[inherit] py-1 w-80 outline-none placeholder-gray-400 text-sm rounded-xl placeholder:text-sm placeholder:font-light"
            />
          </div>

          {selectedPatient && (
            <div className="flex items-center gap-2">
              <Tooltip
                title={
                  !selectedPatient
                    ? "Please select a patient"
                    : "View Diet plans"
                }
              >
                <button
                  disabled={!selectedPatient}
                  onClick={handleDietRouting}
                  className="flex items-center gap-2 px-3 py-1.5 border-2 border-[#189FAA] text-[#189FAA] font-sans text-sm font-semibold rounded-md hover:bg-[#189FAA] hover:text-white transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed group"
                >
                  <span>Diet</span>
                </button>
              </Tooltip>
              <Tooltip
                title={
                  !selectedPatient
                    ? "Please select a patient"
                    : "Set medicine reminder"
                }
              >
                <button
                  disabled={!selectedPatient}
                  onClick={handleMedicineReminder}
                  className="flex items-center gap-2 px-3 py-1.5 border-2 border-[#189FAA] text-[#189FAA] font-sans text-sm font-semibold rounded-md hover:bg-[#189FAA] hover:text-white transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <BellOutlined className="text-base group-hover:animate-bounce" />
                  <span>Medicine</span>
                </button>
              </Tooltip>
            </div>
          )}
        </div>
      </div>

      {/* Search patient modal */}
      <Modal
        title={<span className="text-lg font-medium">Search Patient</span>}
        open={patSearchMod}
        onCancel={handleSearchModal}
        footer={[]}
        destroyOnClose
        width={"25%"}
      >
        <>
          {/* Searching Patient by name or mobile */}
          <form>
            <div>
              <div className="flex flex-col space-y-2 w-full my-4 relative">
                <input
                  ref={nameRef}
                  type="text"
                  id="patientName"
                  name="patientName"
                  placeholder=""
                  className="w-full p-2 border border-[#C3D9DB] rounded-md focus:outline-none text-xs font-medium font-sans peer focus:border-blue-500 text-[#333] bg-transparent"
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^A-Za-z ]/g, "");
                  }}
                />
                <label
                  htmlFor="patientName"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-4 peer-focus:text-blue-500 peer-focus:text-xs bg-brand-White px-1"
                >
                  Name
                </label>
              </div>

              <div className="flex flex-col space-y-2 w-full my-4 relative">
                <input
                  ref={mobileRef}
                  type="text"
                  id="patientMobile"
                  name="patientMobile"
                  placeholder=""
                  className="w-full p-2 border border-[#C3D9DB] rounded-md focus:outline-none text-xs font-medium font-sans peer focus:border-blue-500 text-[#333] bg-transparent"
                  maxLength={15}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
                <label
                  htmlFor="patientMobile"
                  className="text-xs font-medium font-sans text-[#333333] absolute left-2 -top-4 transition-all peer-placeholder-shown:top-0 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-4 peer-focus:text-blue-500 peer-focus:text-xs bg-brand-White px-1"
                >
                  Mobile
                </label>
              </div>
            </div>
            <div
              className={`md:flex-row flex-col md:items-center items-end justify-end gap-3 flex`}
            >
              <button
                type="button"
                onClick={handleSearch}
                disabled={loader}
                className="md:min-w-32 w-[6rem] p-2 bg-[#3B98B9] text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
              >
                Search
              </button>
            </div>
          </form>

          {/* Showing search results */}
          <div className={`${showSearchResult ? "my-3" : "hidden"}`}>
            {isNoPatAvailable ? (
              <div className="w-full flex flex-col items-center text-center mt-6">
                <img
                  src={nosearchfound}
                  alt="no-patient"
                  className="w-10 h-10 mb-3"
                />

                <p className="text-gray-600 text-sm mb-4">
                  No patient found for this number.
                </p>

                <button
                  onClick={handleNewPatRegModal}
                  className="px-5 py-2 bg-brand-primaryColor text-white rounded-md text-sm"
                >
                  Register now
                </button>
              </div>
            ) : (
              searchedPatList?.length !== 0 && (
                <div>
                  <div
                    className={`w-full h-[180px] p-4 bg-white rounded-lg shadow border overflow-y-auto`}
                  >
                    {searchedPatList?.map((patient, idx) => (
                      <div key={idx} className="flex gap-3 items-center my-1">
                        <input
                          type="radio"
                          checked={
                            currSelPat &&
                            currSelPat.patientId === patient.patientId
                          }
                          onChange={(e) => handleRadioChange(e, patient)}
                          className="h-5 w-5 accent-brand-primaryColor cursor-pointer"
                        />

                        {/* <div className="flex flex-col bg-[#F9FDFD] border border-[#A4D3D8] rounded-lg p-4 w-full">
                              <div className="mb-3 border-b">
                                <p className="text-xs text-gray-500">Patient Name</p>
                                <p className="text-base font-semibold">{patient?.firstName + ' ' + patient?.lastName}</p>
                              </div>

                              <div className="mb-3 border-b">
                                <p className="text-xs text-gray-500">Patient ID</p>
                                <p className="text-base font-semibold">{patient?.patientId}</p>
                              </div>

                              <div>
                                <p className="text-xs text-gray-500">Mobile Number</p>
                                <p className="text-base font-semibold">{patient?.mobile}</p>
                              </div>
                            </div> */}
                        <div className="flex items-center gap-3 bg-[#F9FDFD] border border-[#A4D3D8] rounded-lg p-4 w-full">
                          <div className="w-12 h-12 flex items-center justify-center rounded-full p-0 m-0 border-[#D0E2E1] border cursor-pointer bg-white">
                            {patient?.photoName ? (
                              <Avatar
                                size={54}
                                src={`${process.env.REACT_APP_IMAGE_URL}${patient?.photoName}`}
                                className="rounded-full"
                                alt="Logo"
                              />
                            ) : (
                              <FaUser className="w-6 h-6 text-gray-400" />
                            )}
                          </div>
                          <div>
                            <p className="text-base font-semibold">
                              {patient?.firstName + " " + patient?.lastName}
                            </p>
                            <div className="text-gray-500 text-xs font-light">
                              <>
                                <span>PID:</span>
                                <span className="pr-1 border-r-[2.5px]">
                                  {patient?.patientId}
                                </span>
                              </>
                              <span className="px-1 border-r-[2.5px]">
                                {patient?.gender}
                              </span>
                              <span className="pl-1">{patient?.mobile}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="w-full flex justify-end gap-2 mt-4">
                    <button
                      className="p-2 rounded-md border border-brand-primaryColor w-24 bg-white text-brand-primaryColor"
                      onClick={handleSearchModal}
                    >
                      Cancel
                    </button>

                    <button
                      className="p-2 w-24 rounded-lg text-white bg-brand-primaryColor text-sm"
                      onClick={handleSelectedPatient}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )
            )}
          </div>
        </>
      </Modal>

      {/* Patient View and edit */}
      <Modal
        title={
          <h2 className="md:text-2xl text-lg font-bold">Patient Details</h2>
        }
        width={"80%"}
        open={detailedView}
        footer={[]}
        onCancel={handleCloseProfile}
        destroyOnClose
      >
        {/* <PatientDetailsView /> */}
        <AddNewPatient
          handleCancel={handleCloseProfile}
          handleSave={handleSave}
        />
      </Modal>

      <Modal
        title={
          <span className="text-lg font-medium">New Patient Registration</span>
        }
        open={regModal}
        onCancel={handleCloseRegModal}
        footer={[]}
        destroyOnClose
        width={"25%"}
      >
        <div className="w-full p-4 bg-white rounded-md space-y-5">
          {/* Salutation */}
          <div className="relative">
            <select
              name="salutation"
              className="w-full border border-[#C3D9DB] rounded-md px-3 pt-5 pb-2 text-sm peer focus:outline-none focus:border-[#189FAA] disabled:opacity-50 disabled:cursor-not-allowed appearance-none bg-white"
              onChange={handleChange}
              value={formData.salutation}
              disabled={patRegLoader}
            >
              <option value="" disabled hidden></option>
              <option value="Mr.">Mr</option>
              <option value="Ms.">Ms</option>
              <option value="Mrs.">Mrs</option>
            </select>
            <label
              className={`absolute left-3 text-xs font-medium transition-all pointer-events-none
          ${
            formData.salutation
              ? "top-1.5 text-[10px] text-[#189FAA]"
              : "top-3.5 text-sm text-gray-400"
          }`}
            >
              Salutation
            </label>
          </div>

          {/* First Name */}
          <div className="relative">
            <input
              type="text"
              name="firstName"
              placeholder=" "
              className="w-full border border-[#C3D9DB] rounded-md px-3 pt-5 pb-2 text-sm peer focus:outline-none focus:border-[#189FAA] disabled:opacity-50 disabled:cursor-not-allowed"
              onChange={handleChange}
              value={formData.firstName}
              disabled={patRegLoader}
            />
            <label
              className="absolute left-3 top-1.5 text-[10px] text-[#189FAA] font-medium transition-all pointer-events-none
          peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
          peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:text-[#189FAA]"
            >
              First Name <span className="text-red-500">*</span>
            </label>
          </div>

          {/* Last Name */}
          <div className="relative">
            <input
              type="text"
              name="lastName"
              placeholder=" "
              className="w-full border border-[#C3D9DB] rounded-md px-3 pt-5 pb-2 text-sm peer focus:outline-none focus:border-[#189FAA] disabled:opacity-50 disabled:cursor-not-allowed"
              onChange={handleChange}
              value={formData.lastName}
              disabled={patRegLoader}
            />
            <label
              className="absolute left-3 top-1.5 text-[10px] text-[#189FAA] font-medium transition-all pointer-events-none
          peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
          peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:text-[#189FAA]"
            >
              Last Name
            </label>
          </div>

          {/* Mobile */}
          <div className="relative">
            <input
              type="text"
              name="mobile"
              placeholder=" "
              className="w-full border border-[#C3D9DB] rounded-md px-3 pt-5 pb-2 text-sm peer focus:outline-none focus:border-[#189FAA] disabled:opacity-50 disabled:cursor-not-allowed"
              onChange={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                handleChange(e);
              }}
              value={formData.mobile}
              maxLength={15}
              disabled={patRegLoader}
            />
            <label
              className="absolute left-3 top-1.5 text-[10px] text-[#189FAA] font-medium transition-all pointer-events-none
          peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
          peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:text-[#189FAA]"
            >
              Mobile <span className="text-red-500">*</span>
            </label>
          </div>

          {/* Email */}
          <div className="relative">
            <input
              type="email"
              name="email"
              placeholder=" "
              className="w-full border border-[#C3D9DB] rounded-md px-3 pt-5 pb-2 text-sm peer focus:outline-none focus:border-[#189FAA] disabled:opacity-50 disabled:cursor-not-allowed"
              onChange={handleChange}
              value={formData.email}
              disabled={patRegLoader}
            />
            <label
              className="absolute left-3 top-1.5 text-[10px] text-[#189FAA] font-medium transition-all pointer-events-none
          peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
          peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:text-[#189FAA]"
            >
              Email Id
            </label>
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button
              disabled={patRegLoader}
              className="px-5 py-2 rounded-md border border-[#189FAA] text-[#189FAA] bg-white disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleCloseRegModal}
            >
              Cancel
            </button>
            <button
              disabled={patRegLoader}
              className="px-5 py-2 rounded-md bg-[#189FAA] text-white disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleNewPatRegistration}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>

      {/* Medicine Reminder List Modal */}
      <MedicineReminderListModal
        open={medReminderOpen}
        onClose={() => setMedReminderOpen(false)}
        selectedPatient={selectedPatient}
        nosearchfoundImg={nosearchfound}
        onAddNew={() => {
          setMedReminderOpen(false);
          setMedReminderAddOpen(true);
        }}
      />
 
      {/* Medicine Reminder Add Modal */}
      <MedicineReminderModal
        open={medReminderAddOpen}
        onClose={() => setMedReminderAddOpen(false)}
        selectedPatient={selectedPatient}
        loggedUser={loggedUser}
      />
    </>
  );
}

export default PatientSearch;
